




























import { mapActions, mapGetters } from 'vuex';

import { ApiEnum } from '../enums';

import { USER_CONSTS } from '../store/user/user.consts';

import { UiButton, UiTextbox, UsersPassword } from '../components';

export default {
  name: 'account',
  components: {
    UiTextbox,
    UsersPassword,
    UiButton
  },
  computed: {
    ...mapGetters(USER_CONSTS.moduleName, {
      user: USER_CONSTS.getters.user
    }),
    valid: function () {
      return (!!this.user.firstName && !!this.user.lastName && this.isPasswordValid);
    }
  },
  data: function () {
    return {
      isPasswordValid: true,
      messages: this.$epb.messages.tools.users
    };
  },
  methods: {
    ...mapActions(USER_CONSTS.moduleName, {
      loadUser: USER_CONSTS.actions.loadUser,
      persistUser: USER_CONSTS.actions.persistUser
    }),
    onPasswordChange: function ({ value: password, valid }): void {
      this.user.password = password;
      this.user.passwordConfirm = password;
      this.isPasswordValid = valid;
    },
    onAccept: async function (): Promise<void> {
      this.$emit('updateLoading', { visible: true });
      try {
        await this.persistUser(this.user);
        this.$emit('showSnackbar', this.messages.update.success);
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.USERS));
      } finally {
        this.$emit('updateLoading', { visible: false });
      }
    }
  },
  created: async function (): Promise<void> {
    this.$emit('updateLoading', { visible: true });
    try {
      await this.loadUser();
    } catch (error) {
      this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.USERS));
    } finally {
      this.$emit('updateLoading', { visible: false });
    }
  }
};

